<template>
  <a-locale-provider :locale="locale">
    <div id="app">
      <router-view/>
    </div>
  </a-locale-provider>
</template>

<script>
  import moment from 'moment';
  import 'moment/locale/zh-cn';
  import enquireScreen from './utils/device';
  import config from '../config';
  import Cookies from 'js-cookie';
  moment.locale('zh-cn');
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
  export default {
    name: 'App',
    data(){
      return {
        locale: zhCN,
      }
    },
    created() {
      window.vm = this;
      enquireScreen(
        isMobile => {
          this.$store.commit('setting/setMobileDevice', isMobile);
        },
        isSmallLaptop => {
          this.$store.commit('setting/setSmallLaptopDevice', isSmallLaptop);
        }
      );

      // 1. 判断这个路由是否需要登录（out）
      // 2. 从cookie中取token  (out)
      // 3. 验证token是否有效 （out）

      // // 判断是否token过期
      // this.$ajax.gateway('/platform/user_getCurrentUser').then(data => {
      //   this.$store.commit('setUserInfo', data.data);
      // });
      setTimeout(()=>{
        try{
          // 取ico或者logo
          let url = window.NODE_CONFIG.web.areaData.icon || window.NODE_CONFIG.web.areaData.logo;
          if(url) {
            let link = document.querySelector("link[rel*='icon']") ||
            document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = url;
            document.getElementsByTagName('head')[0].appendChild(link);
          }
        }catch(e){
          console.log(e);
        }
      },100);
    }
  };
</script>

<style lang="stylus">
  :global
    // 拖拽控件全局样式
    .dragable-ghost
      border 1px dashed #aaaaaa
      opacity 0.65
    .dragable-chose
      border 1px dashed #aaaaaa
      opacity 0.65
    .dragable-drag
      border 1px dashed #aaaaaa
      opacity 0.65
    // 页面切换动画
    .page-toggle-enter-active
      transition all 0.2s ease-in 0.25s
    .page-toggle-leave-active
      transition all 0.2s ease-out 0s
    .page-toggle-enter,
    .page-toggle-leave-to
      opacity 0
      padding 0px

	// .body-mobile
	// 	.md-icon-check:before
	// 		width .26rem
	// 		height .26rem
	// 		content ' '
	// 		border-radius 100%
	// 		border 1px solid #ccc
	// 	.md-icon.md-icon-checked:before,
	// 	.md-icon.md-icon-success:before
	// 		width .26rem
	// 		height .26rem
	// 		line-height .26rem
	// 		content '√'
	// 		color #fff
	// 		font-size .16rem
	// 		text-align center
	// 		background #3399ff
	// 		border-radius 100%
	// 		border 1px solid #3399ff
</style>
